import { Umbrella, Wind } from "lucide-react";
import { kmh, localDay, wIcon } from "@/lib/weather";
import { useT } from "@/lib/i18n";

export const DailyList = ({ data }) => {
  const { t, lang } = useT();
  const days = data.daily || [];
  const lo = Math.min(...days.map((d) => d.temp.min));
  const hi = Math.max(...days.map((d) => d.temp.max));
  const pct = (v) => ((v - lo) / (hi - lo || 1)) * 100;
  return (
    <section data-testid="weather-daily" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4">
      <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-2">{t("wx_next_days")}</div>
      <div className="divide-y divide-[#282D3D]">
        {days.map((d, i) => {
          const Icon = wIcon(d.weather?.[0]?.icon);
          const pop = Math.round((d.pop || 0) * 100);
          return (
            <div key={d.dt} data-testid={`weather-day-${i}`} className="grid grid-cols-[64px_28px_1fr_auto] sm:grid-cols-[80px_32px_minmax(0,1fr)_160px_120px] items-center gap-3 py-2">
              <div className="font-heading uppercase text-base">{i === 0 ? t("wx_today") : localDay(d.dt, data.timezone_offset, lang)}</div>
              <Icon className="w-6 h-6 text-[#FFB800]" />
              <div className="font-mono text-[11px] text-slate-400 truncate capitalize">{d.weather?.[0]?.description}</div>
              <div className="hidden sm:flex items-center gap-2 font-mono text-xs tabular-nums">
                <span className="text-slate-400 w-7 text-right">{Math.round(d.temp.min)}°</span>
                <div className="relative flex-1 h-1.5 bg-[#282D3D] rounded-full">
                  <div className="absolute h-full rounded-full bg-gradient-to-r from-[#007AFF] to-[#FFB800]" style={{ left: `${pct(d.temp.min)}%`, right: `${100 - pct(d.temp.max)}%` }} />
                </div>
                <span className="w-7">{Math.round(d.temp.max)}°</span>
              </div>
              <div className="flex items-center gap-3 justify-end font-mono text-[11px]">
                <span className="sm:hidden tabular-nums">{Math.round(d.temp.min)}°/{Math.round(d.temp.max)}°</span>
                <span className={`inline-flex items-center gap-1 ${pop >= 30 ? "text-[#007AFF]" : "text-slate-500"}`}><Umbrella className="w-3 h-3" />{pop}%</span>
                <span className="hidden sm:inline-flex items-center gap-1 text-slate-400"><Wind className="w-3 h-3" />{kmh(d.wind_speed)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
